import { render, staticRenderFns } from "./CategoryDataCard.vue?vue&type=template&id=22219750"
import script from "./CategoryDataCard.vue?vue&type=script&lang=js"
export * from "./CategoryDataCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports